import UserCard from './UserCard.vue';

export default UserCard;
